import { IUpdateCallingSystemRequest, IUpdateCallingSystemResponse } from "../../../Types/UsersCallingSystem";
import ApiService from "../../ApiService";

class CallingSystemService extends ApiService {

  async updateCallingSystemStatus(payload: IUpdateCallingSystemRequest): Promise<IUpdateCallingSystemResponse> {
    return this.post<IUpdateCallingSystemResponse>(
      "/calling-system/assign-manage",
      payload
    );
  }
}

export const callingSystemService = new CallingSystemService();
